import { useEffect, useState } from "react";
import Api from "../../../../services/Api";
import Functions from "../../../../services/Functions";
import BigCard from "../../../general/BigCard";
import styles from "./InfraL2.module.css";
import Leaflet from "./maps/LeafletMap";

function InfraL2({ distrito }) {
  const [numeroPropriedades, setNumeroPropriedades] = useState(null);
  const [areaMedia, setAreaMedia] = useState(null);
  const [numeroNascentes, setNumeroNascentes] = useState(null);
  const [dificuldade, setDificuldade] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const [numeroPropriedades, areaMedia] =
          await Promise.all([
            Api.getNumeroPropriedades2(
              distrito,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null,
              null
            ),
            Api.getAreaMediaDistrito(distrito),
          ]);
        setNumeroPropriedades(numeroPropriedades);
        setAreaMedia(areaMedia);
      } catch (error) {
        console.error("Erro ao buscar dados:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [distrito]);

  return (
    <div className={styles.infraL2}>
      <div className={styles.cards}>
        <div className={styles.card}>
          <BigCard name="Propriedades" value={numeroPropriedades?.value} />
        </div>
        <div className={styles.card}>
          <BigCard
            name={
              <>
                Área Média
                <br />
                (ha)
              </>
            }
            value={areaMedia?.value?.toFixed(2)}
          />
        </div>
      </div>

      <div className={styles.map}>
        <Leaflet distrito={distrito} />
      </div>
    </div>
  );
}

export default InfraL2;
